<div class="header">
  <div class="sub-header">
    <div class="left">
      <img src="assets/images/logo_bps.png" alt="Logo" class="logo" />
    </div>
    <div class="center">
      <h2>Administrador de asistentes</h2>
    </div>
    <div class="right">
      <span class="material-icons"> person </span>
      <span>{{ nombreUsuario }}</span>
      <button
        type="button"
        class="btn logout-btn"
        (click)="salirAdministrador()"
      >
        <span>Salir</span
        ><span class="material-icons icon-logout"> logout </span>
      </button>
    </div>
  </div>
  <app-navegacion
    [sub_titulo]="sub_titulo"
    [todas_opciones]="todas_opciones"
    [ruta_volver]="path ? path:'/config/home'"
  ></app-navegacion>
</div>
